export default __webpack_public_path__ + "static/media/regreenbus_intro_logo_bus.417bb1df.png";